<div id="non_covered">
  <p class="p1">Normalize Forecasts on this company?</p>
  <br />
  <p class="p2">
    Raw analyst model access is available on this company, and we hope you find
    it useful - but many more unique insights can be uncovered when we process
    all the data in the models and create normalized and consensus assumptions
    and forecasts.
  </p>
  <br />
  <p class="p3">
    We are adding new companies to our database all the time. If you would like
    us to prioritize {{ companyName }} for coverage, please tell us!
  </p>
  <div
    *ngIf="userType !== 'MODELS_ONLY_INBOX'"
    style="float: right;margin-right: 10px;"
  >
    <button
      id="normalizeForecastBtn"
      (click)="setPrioritize()"
      class="secondary-button-medium"
      [ngClass]="{ disabled: normalizeForecastBtnText === 'Requested' }"
      [disabled]="normalizeForecastBtnText === 'Requested'"
    >
      {{ normalizeForecastBtnText }}
    </button>
  </div>
</div>
